// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"5e404897","189":"fbe70fbf","218":"b7695eae","586":"50f51b4d","694":"c894b8de","715":"8c62cb93","926":"72f098b1","973":"a846790c"}[chunkId] + ".chunk.js";
};